import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import { fetchFiltersData } from "@/reducers/clientscandidates";
import {
  setUnfilledContractsLoading,
  updatePagination,
  deSelectAllContract,
  showFilterModal,
  fetchUnfilledContracts,
  updateFilters,
  reStateFilters,
} from "@/reducers/clientunfilledcontracts";

import CalendarFilter from "../../ListingFilters/CalendarFilter";
import DropDownFilter from "../../ListingFilters/DropDownFilter";
import FilterModalBottomAction from "../../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../../ListingFilters/FilterModalTop";

/**
 * Renders the FilterModal component with various filter options and actions.
 *
 * @return {JSX.Element} The rendered FilterModal component
 */
export const FilterModal = () => {
  const dispatch = useDispatch();
  const { filters, showFilters, pagination, listView } = useSelector(
    (state) => state.clientUnfilledContracts,
  );
  const { filterLists } = useSelector((state) => state.clientsCandidates);
  /**
   * Function to handle the closing of the modal.
   *
   * @param {boolean} fromBtn - indicates if the function was called from a button
   * @return {void}
   */
  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateFilters());
    }
    dispatch(showFilterModal(false));
  };
  useEffect(() => {
    dispatch(fetchFiltersData());
  }, []);
  /**
   * This function handles the apply action by dispatching various actions and closing a modal.
   */
  const handleApply = () => {
    dispatch(deSelectAllContract());
    dispatch(setUnfilledContractsLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(fetchUnfilledContracts(filters));
    handleClose();
  };
  /**
   * Function to handle reset.
   */
  const handleReset = () => {
    dispatch(deSelectAllContract());
    dispatch(updateFilters({}));
    dispatch(setUnfilledContractsLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(
      fetchUnfilledContracts({
        search: filters.search,
      }),
    );
    handleClose();
  };
  return (
    <ModalPopUp
      show={showFilters}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose(true);
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[18px]">
          <div className="grix gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <div className="grid gap-3">
              <label className="label text-black" htmlFor="contractReferenceNo">
                Contract Reference No.
              </label>
              <input
                type="text"
                className="ease h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black transition-all duration-200 placeholder:font-medium placeholder:text-txtColor focus:border-primary"
                placeholder="Enter Reference No."
                onChange={(e) => {
                  dispatch(
                    updateFilters({ contractReferenceNo: e.target.value }),
                  );
                }}
                value={filters.contractReferenceNo}
                onKeyUp={(e) => {
                  if (e.keyCode === 13) {
                    handleApply();
                  }
                }}
              />
            </div>

            {/* <DropDownFilter
                            options={
                                unfilledContractStatus && unfilledContractStatus.length > 0
                                    ? unfilledContractStatus
                                    : []
                            } // this is the list of roles
                            id="contractStatus"
                            label="Contract Status"
                            placeholder="Select Contract Status"
                            value={filters?.contractStatus} // selected role
                            handleChange={(value) => {
                                dispatch(updateFilters({ contractStatus: value }));
                            }} // function to handle change of role
                            isMultiple={false}
                        /> */}
            <DropDownFilter
              options={
                filterLists && filterLists?.allRoles?.length > 0
                  ? filterLists?.allRoles
                  : []
              } // this is the list of roles
              id="roleId"
              label="Role"
              placeholder="Select Role"
              value={filters.roleId} // selected role
              handleChange={(value) => {
                dispatch(updateFilters({ roleId: value }));
              }} // function to handle change of role
              isMultiple={true}
            />

            {/* <DropDownFilter
                            options={
                                filterLists && filterLists?.allUsers?.length > 0
                                    ? filterLists?.allUsers.filter((user) => user.type !== "candidate")
                                    : []
                            } // this is the list of roles
                            id="Created By"
                            label="Created By"
                            // isMultiple="false"
                            placeholder="Select Created By"
                            value={filters.actionedById} // selected role
                            handleChange={(value, type) => {

                                dispatch(updateFilters({ actionedById: value, actionedByType: type }));
                            }} // function to handle change of role
                        /> */}
          </div>
          <div className="_filter_calendar">
            <CalendarFilter
              label="Created Date (From - To)"
              dateFrom={filters.createdDateFrom}
              dateTo={filters.createdDateTo}
              handleChange={(value) => {
                dispatch(
                  updateFilters({
                    createdDateFrom: value.dateFrom,
                    createdDateTo: value.dateTo,
                  }),
                );
              }}
            />
          </div>
          <div className="_filter_calendar">
            <CalendarFilter
              label="Shift Date (From - To)"
              dateFrom={filters.shiftDateFrom}
              dateTo={filters.shiftDateTo}
              handleChange={(value) => {
                dispatch(
                  updateFilters({
                    shiftDateFrom: value.dateFrom,
                    shiftDateTo: value.dateTo,
                  }),
                );
              }}
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};
